// extracted by mini-css-extract-plugin
module.exports = {"root":"meetings-view_root__2SrzT","title":"meetings-view_title__keRcc","gridHeader":"meetings-view_gridHeader__3tOQ7","activeColumn":"meetings-view_activeColumn__EHU2B"};